import { h, Component } from 'preact';
import Store from 'store/store';
import { joinClasses } from 'utils/utils';
import { TicketCross, TicketTick } from 'helpers/svgs';
import { cancelTickets } from 'helpers/tickets';
import { checkAccessCode } from 'helpers/earlyAccess';
import {
	MANAGE_TICKETS,
	CROSS,
	CLOSE,
	CLEAR,
	CONFIRM_CANCEL_ONE,
	CONFIRM_CANCEL_MULTIPLE,
	BACK_TO_TICKET,
	CANCEL_ONE_TICKET,
	CANCEL_UP_TO_ALL_TICKETS,
	ENTER_EARLY_ACCESS_CODE,
	SUBMIT_CODE,
	ADD_TO_WATCHLIST
} from 'helpers/constants';
// import Store from 'store/store';
import Counter from 'components/bolt/counter/counter';
import s from 'components/bolt/infoScreen/infoScreen.sss';


export default class InfoScreen extends Component {
	constructor(props) {
		super(props);
		this.state = {
			numTicketsToCancel: 2,
			codeInput: null
		};
		this.onCodeInput = this.onCodeInput.bind(this);
		this.onInputKeyUp = this.onInputKeyUp.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (this.props.ticketData?.length > 0 && (prevProps.ticketData !== this.props.ticketData)) {
			this.setState({
				numTicketsToCancel: this.props.ticketData?.length || 2
			});
		}
	}

	onBtnClick(action) {
		const { data } = this.props;
		const { codeInput } = this.state;

		if (action === CLOSE) {
			Store.emit('HIDE_INFO_SCREEN');
		}
		if (action === MANAGE_TICKETS || action === BACK_TO_TICKET) {
			Store.emit('HIDE_INFO_SCREEN');
			Store.emit('SHOW_TICKET_AREA', true);
		}
		if (action === CANCEL_ONE_TICKET) {
			cancelTickets(1);
		}
		if (action === CANCEL_UP_TO_ALL_TICKETS) {
			cancelTickets(this.state.numTicketsToCancel);
		}
		if (action === MANAGE_TICKETS) {
			Store.emit('TRACK_MANAGE_TICKETS');
		}
		if (action === SUBMIT_CODE) {
			const code = codeInput || this.$codeInput?.value;
			if (!code ) return;
			checkAccessCode(data.screeningId, code, data.onAccessCodeSuccess);
		}
		if (action === ADD_TO_WATCHLIST) {
			Store.emit('ADD_TO_WATCHLIST');
		}
	}

	onCodeInput(e) {
		this.setState({
			codeInput: (e.target.value || '').toUpperCase()
		});
	}

	onInputKeyUp(e) {
		if (e.keyCode === 13) {
			this.onBtnClick(SUBMIT_CODE);
		}
	}

	changeTicketNum(delta, disabled) {
		if (disabled) return;

		const { numTicketsToCancel } = this.state;
		this.setState({
			numTicketsToCancel: numTicketsToCancel + delta
		});
	}

	renderIcon(ticketIcon) {
		if (ticketIcon === CROSS) {
			return <TicketCross class={s.icon} />;
		}
		return <TicketTick class={s.icon} />;
	}

	renderCodeInput() {
		const { ticketData, storedEarlyAccessCode } = this.props;
		const inputValue = this.state.codeInput !== null ? this.state.codeInput : storedEarlyAccessCode || ticketData?.[0]?.earlyAccessCode || '';

		return (
			<div class={s.codeInputContainer}>
				<input
					ref={$ref => this.$codeInput = $ref}
					class={s.codeInput}
					onInput={this.onCodeInput}
					onKeyUp={this.onInputKeyUp}
					value={inputValue.toUpperCase()}
					maxLength={24}
				/>
			</div>
		);
	}

	renderButtons(buttons) {
		if (!buttons || buttons.length < 1) return;
		const { data } = this.props;
		const rowButtons = data.type === CONFIRM_CANCEL_ONE || data.type === CONFIRM_CANCEL_MULTIPLE;
		
		return (
			<div class={joinClasses(s.btns, rowButtons && s.rowBtns)}>
				{buttons.map(btn => (
					<button class={joinClasses(s.btn, (btn.type === CLEAR) && s.clearBtn)} onClick={() => this.onBtnClick(btn?.action)}>
						{btn.text}
					</button>
				))}
			</div>
		);
	}

	render(props) {
		const { show, data, ticketData } = props;
		const { numTicketsToCancel } = this.state;
		const userTickets = ticketData?.length || 0;
		const showCounter = data?.type === CONFIRM_CANCEL_MULTIPLE;
		const showInputField = data?.type === ENTER_EARLY_ACCESS_CODE;
		const minusDisabled = numTicketsToCancel === 1;
		const plusDisabled = numTicketsToCancel >= userTickets;

		return (
			<div class={joinClasses(s.container, show && s.show)}>
				<div class={s.infoBox}>
					{this.renderIcon(data?.ticketIcon)}
					<p class={s.message}>{data?.message}</p>
					<p class={s.additionalMessage}>{data?.additionalMessage}</p>
					{showInputField && this.renderCodeInput()}
					{showCounter && (
						<Counter
							extraClass={s.counter}
							numTicketsSelected={numTicketsToCancel}
							minusDisabled={minusDisabled}
							plusDisabled={plusDisabled}
							minusOnClick={() => this.changeTicketNum(-1, minusDisabled)}
							plusOnClick={() => this.changeTicketNum(1, plusDisabled)}
						/>
					)}
					{this.renderButtons(data?.buttons)}
				</div>
			</div>
		);
	}
}